import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { ItemImageColumnId, itemImageDataBuilder } from '../../../../items/items-table/columns/item-image';
import { ItemNameColumnId, itemNameDataBuilder } from '../../../../items/items-table/columns/item-name';
import { ItemQuantityColumnId, itemQuantityDataBuilder } from '../../../../items/items-table/columns/item-quantity';
import { ItemReturnReasonColumnId, itemReturnReasonDataBuilder } from '../../../../items/items-table/columns/item-return-reason';
import { ItemTotalColumnId, itemTotalDataBuilder } from '../../../../items/items-table/columns/item-total';
import { ShipmentItemsTableEmptyRow } from '../../../../items/items-table/empty-row/shipment-items-table-empty-row';
import ItemsTable from '../../../../items/items-table/items-table';
import { useHiddenColumnsForTableWidth } from '../../../../items/items-table/use-hidden-columns-for-table-width';
import columns from '../columns';

const hiddenColumnsForWidthMap = {
  544: [ItemImageColumnId, ItemReturnReasonColumnId],
};

const ReturnItemsTable = ({ items, containerWidth }) => {
  const hiddenColumns = useHiddenColumnsForTableWidth(containerWidth, hiddenColumnsForWidthMap);

  const formattedItems = useMemo(() => {
    return items.map((item) => {
      return {
        [ItemNameColumnId]: itemNameDataBuilder(item),
        [ItemImageColumnId]: itemImageDataBuilder(item),
        [ItemQuantityColumnId]: itemQuantityDataBuilder(item),
        [ItemTotalColumnId]: itemTotalDataBuilder(item),
        [ItemReturnReasonColumnId]: itemReturnReasonDataBuilder(item),
      };
    });
  }, [items]);

  return (
    <ItemsTable columns={columns} emptyRow={<ShipmentItemsTableEmptyRow isReturn />} hiddenColumns={hiddenColumns} items={formattedItems} />
  );
};

export default ReturnItemsTable;

ReturnItemsTable.propTypes = {
  items: PropTypes.array.isRequired,
  containerWidth: PropTypes.number.isRequired,
};
